import { IconComponentConfig } from '../icon';

export interface RadioGroupOptions {
  value: any;
  label?: string;
  key?: string;
  labelSize?: string;
  icon?: IconComponentConfig;
  iconSize?: string;
  tooltip?: string;
  customHTML?: string;
}
